import { render, staticRenderFns } from "./ActualPaper.vue?vue&type=template&id=527b6fb4&scoped=true&"
import script from "./ActualPaper.vue?vue&type=script&lang=js&"
export * from "./ActualPaper.vue?vue&type=script&lang=js&"
import style0 from "./ActualPaper.vue?vue&type=style&index=0&id=527b6fb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b6fb4",
  null
  
)

export default component.exports